import { Button, IconButton, Stack, Typography, useTheme } from '@mui/material';
import { IconX } from '@tabler/icons';
import { useModal } from 'mui-modal-provider';

import { Dispatch, ReactElement, SetStateAction } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  name: string;
  fileList: File[] | null;
  setFileList: Dispatch<SetStateAction<any[] | null>>;
  label?: string;
  description?: string;
  endIcon?: ReactElement;
  single?: boolean;
  error?: string;
  setError?: (errorMessage: string) => void;
  maxSizeInMB?: number;
  onFileSelectionChange?: (selected: boolean) => void;
}

const MultiFileUploader = ({ name, fileList, setFileList, endIcon, label, description, single }: Props) => {
  const theme = useTheme();
  const intl = useIntl();
  const { showModal } = useModal();

  const handleOnchange = (e: any) => {
    setFileList((oldvalue) => (oldvalue ? [...oldvalue, e.target.files[0]] : [e.target.files[0]]));
  };

  const handleDelete = (value: any) => {
    if (fileList) setFileList(fileList.filter((file) => file.name !== value));
  };

  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Button variant="contained" color="primary" component="label" endIcon={endIcon} sx={{ minWidth: 160 }}>
          {label || intl.formatMessage({ defaultMessage: 'Upload File' })}
          <input type="file" hidden onChange={handleOnchange} multiple={!single} name={name} />
        </Button>
        {!fileList?.length ? (
          <Typography>{intl.formatMessage({ defaultMessage: 'No file chosen' })}</Typography>
        ) : (
          <Stack direction={'row'} spacing={2} rowGap={2} flexWrap="wrap">
            {fileList.map(
              (file, index) =>
                file && (
                  <Stack
                    key={file.name + index}
                    direction="row"
                    alignItems="center"
                    sx={{
                      borderWidth: 1,
                      borderStyle: 'solid',
                      borderColor: theme.palette.grey[500],
                      borderRadius: theme.shape.borderRadius
                    }}
                  >
                    <Typography sx={{ fontSize: 13, pl: 1, maxWidth: 350 }}>{file.name}</Typography>
                    <IconButton
                      onClick={() => handleDelete(file.name)}
                      sx={{
                        m: 0.5,
                        p: 0.4,
                        backgroundColor: '#555',
                        '&:hover': {
                          backgroundColor: '#666'
                        }
                      }}
                    >
                      <IconX style={{ width: 15, height: 15, color: 'white' }} />
                    </IconButton>
                  </Stack>
                )
            )}
          </Stack>
        )}
      </Stack>
      {description && <Typography>{description}</Typography>}
    </Stack>
  );
};

export default MultiFileUploader;
